import { useContext } from "react";
import { AppContext } from "../App";
import { RiHome6Line } from "react-icons/ri";
import { FaRegUser } from "react-icons/fa";
import { STR_ACCOUNT, STR_MENU_HOME, STR_MENU_LOANS } from "../Strings";
import { LiaUserSolid } from "react-icons/lia";
import { LuShoppingCart } from "react-icons/lu";
import { MdOutbond, MdPaid, MdSavings } from "react-icons/md";

export default function BottomBar() {
  const appContext = useContext(AppContext);

  return (
    <div className="BottomBar">
      <div className="barInner">

        <div
          className="mIcon"
          data-active={appContext.navItem === 'home' || !appContext.navItem}
          onClick={() => appContext.navTo({ item: 'home' })}
        >
          <RiHome6Line className="mSymbol" />
          <div className="mText">{STR_MENU_HOME[appContext.language]}</div>
        </div>

        <div
          className="mIcon"
          data-active={appContext.navItem === 'loans'}
          onClick={() => appContext.navTo({ item: 'loans' })}
        >
          <MdPaid className="mSymbol" />
          <div className="mText">{STR_MENU_LOANS[appContext.language]}</div>
        </div>

        <div
          className="mIcon"
          data-active={appContext.navItem === 'account'}
          onClick={() => appContext.navTo({ item: 'account' })}
        >
          <LiaUserSolid className="mSymbol" />
          <div className="mText">{STR_ACCOUNT[appContext.language]}</div>
        </div>

      </div>
    </div>
  );
}
